module.exports = __webpack_public_path__ + "static/unity-grayscaled-70354581cf1db2fc6ab7335aca2699e3.png";